import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { path } from 'ramda';
import config from '../generated/config';

import Success from '../icons/success';
import Eye from '../icons/eye-svg';
import teamMembers from '../commons/utils/team-members';
import Input from '../commons/component/input';
import Button from '../commons/component/button';
import AlertBox from '../commons/component/alert-box'

import PasswordScore from './password-score';
import Error, { hasNamedError } from '../commons/component/error';
import { changePassword } from '../api/customer/change-password';
import { getAllQueryParams } from '../commons/query';

import Recaptcha from '../commons/component/captcha/recaptcha';
import AempUserIcon from '../icons/aemp-user-icon';

class AlterarSenhaComponent extends Component {
  state = {
    teamMember: teamMembers(),
    newPassword: '',
    newPasswordConfirmation: '',
    showNewPassword: false,
    showNewPasswordConfirmation: false,
    passwordScore: 0,
    isFormSubmitting: false,
    isPasswordChangedSuccessfully: false,
    errors: {}
  };

  render() {
    if (this.state.isPasswordChangedSuccessfully) {
      return (
        <div id="results">
          <div className="alterarSenhaForm-container">
            <h2 className="cadastroForm-title">
              <AempUserIcon />
              <span>Alterar senha</span>
            </h2>
            <div className="messagemSucessoContainer">
              <Success />
              <span className='sucessoSolicitacao'>
                Solicitação concluída :)
              </span>
              <span className="mensagemSucesso">
                agora você pode acessar sua conta com seu login atual e sua nova senha.
              </span>
            </div>


            <Button
              primary
              onClick={() => {
                window.location = `${path(['url', 'home'], config)}`;
              }}
              className="cadastroForm-submit"
            >
              Voltar para a Home

            </Button >
          </div >
        </div >

      );
    }

    return (
      <div className="alterarSenhaForm-container">
        <h2 className="cadastroForm-title">
          <AempUserIcon />
          <span>Alterar senha</span>
        </h2>

        <p className="paragraph">digite sua nova senha com no mínimo 6 caracteres nos campos abaixo e volte a usar a americanas empresas</p>
        <AlertBox errors={this.state.errors}></AlertBox>


        <form className="cadastroForm" onSubmit={this.updatePassword.bind(this)}>
          <div className="inputGroup" id="new-password">
            <label className={`inputGroup-label${this.hasError('titleError') && '--error'}`} htmlFor="password-input">
              nova senha
            </label>
            <div className="passwordWrapper">
              <Input
                name="new-password"
                id="new-password-input"
                data-form="signup"
                data-page="signup"
                type={this.state.showNewPassword ? 'text' : 'password'}
                onChange={this.changeNewPassword.bind(this)}
                value={this.state.newPassword}
                className={`inputGroup-input --withAddOn ${this.hasError('password')}`}
                autoComplete={false}
              />
              <div
                role="button"
                className="inputGroup-addOn"
                onClick={this.toggleShow('showNewPassword')}
              >
                <Eye on={!this.state.showNewPassword} />
              </div>
            </div>
            <PasswordScore className="inputGroup-score" score={this.state.passwordScore} />
            <Error className="--addOn" errors={this.state.errors} name="newPassword" />
          </div>

          <div className="inputGroup" id="new-password-confirmation">
            <label className="inputGroup-label" htmlFor="password-input">
              repetir senha
            </label>
            <div className="passwordWrapper">
              <Input
                name="new-password-confirmation"
                id="new-password-confirmation-input"
                data-form="signup"
                data-page="signup"
                type={this.state.showNewPasswordConfirmation ? 'text' : 'password'}
                onChange={this.changeNewPasswordConfirmation.bind(this)}
                value={this.state.newPasswordConfirmation}
                className={`inputGroup-input --withAddOn ${this.hasError(
                  'titleError'
                )}`}
                autoComplete={false}
              />
              <div
                role="button"
                className="inputGroup-addOn"
                onClick={this.toggleShow('showNewPasswordConfirmation')}
              >
                <Eye on={!this.state.showNewPasswordConfirmation} />
              </div>
            </div>
            <Error errors={this.state.errors} name="newPasswordConfirmation" />
          </div>
          <div className="tipsGroup">
            <span className='dicaSeguranca'>dicas para criar uma senha mais segura:</span>
            <ul>
              <li>Combine letras maiúsculas e minúsculas, símbolos e números</li>
              <li>Não use informações pessoais</li>
              <li>Para maior segurança, defina uma senha diferente da anterior</li>
            </ul>
          </div>

          {config.enableCaptchaOnChangePassword && <Recaptcha ref={ref => (this.captcha = ref)} />}

          <Button
            primary
            disabled={this.state.isFormSubmitting}
            loading={this.state.isFormSubmitting}
            className="cadastroForm-submit"
          >
            Salvar
          </Button>
          <Error errors={this.state.errors} name="errorMessage" />
        </form>
      </div>
    );
  }

  async updatePassword(evt) {
    try {
      evt.preventDefault();

      if (this.state.newPassword === this.state.newPasswordConfirmation) {
        this.setState({ isFormSubmitting: true });
        const { token } = getAllQueryParams();
        const captchaResponse = config.enableCaptchaOnChangePassword
          ? await this.captcha.getResponse()
          : '';
        const { errors } = await changePassword(this.state.newPassword, token, captchaResponse);

        if (errors) {
          throw errors;
        } else {
          this.setState({ isPasswordChangedSuccessfully: true });
        }
      } else {
        this.setState({
          errors: { titleError: 'senhas não conferem', messageError: 'as senhas informadas não estão iguais' },
          isFormSubmitting: false
        });
      }
    } catch (errors) {
      console.error(errors);
      if (errors !== 'request timeout' && config.enableCaptchaOnChangePassword) {
        this.captcha.reset();
      }

      this.setState({ errors, isFormSubmitting: false });
    }
  }

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  changeNewPasswordConfirmation(e) {
    const newPasswordConfirmation = e.target.value;
    this.setState({
      newPasswordConfirmation
    });
  }

  changeNewPassword(e) {
    const newPassword = e.target.value;
    this.setState({
      newPassword
    });
    this.checkPasswordStrength(newPassword);
  }

  toggleShow(name) {
    return e =>
      this.setState({
        [name]: !this.state[name]
      });
  }

  checkPasswordStrength(password) {
    if (password) {
      this.setState({
        passwordScore: (window.zxcvbn && window.zxcvbn(password).score) || 0
      });
    } else {
      this.setState({ passwordScore: 0 });
    }
  }
}

class AlterarSenhaContainer extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          path="/alterar-senha"
          children={() => <AlterarSenhaComponent history={this.props.history} />}
        />
        <Redirect to="/alterar-senha" />
      </Switch>
    );
  }
}

export default withRouter(AlterarSenhaContainer);
